module.exports = __webpack_public_path__ + "img/directions.3910f55e.svg";